module.exports = __webpack_public_path__ + "img/full1-min.fdef0e95.png";